import React, { Fragment, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { Row, Col, Container, Modal } from 'react-bootstrap';
import { AppContext } from '../../contexts/AppContext';
import { Box } from 'theme-ui';
import { TaskType } from '../../contexts/contextTypes';

const TrackingHistory = () => {
  const { t } = useTranslation();
  const { trackingDetails, partner, settings } = useContext(AppContext);
  const [isOpenImages, setIsOpenImages] = useState<boolean>(false);
  const trackingEvents = trackingDetails?.trackingEvents || [];
  const taskType = trackingDetails?.task?.taskType;
  const isLockerTask = taskType === TaskType.LOCKER_DELIVERY || taskType === TaskType.LOCKER_PICKUP;

  const renderPhotos = () => {
    if (!settings?.displayDeliveryConfirmationPhotos || !trackingDetails?.verifiedPhotoUrls?.length) {
      return null;
    }

    return (
      <div>
        {trackingDetails.verifiedPhotoUrls.map((photoUrl, index) => (
          <img alt="photoVerification" key={`verifiedPhoto_${index}`} className="feedback_success--img" src={photoUrl} onClick={() => setIsOpenImages(true)} />
        ))}
      </div>
    );
  };

  const getEventTranslationKey = (eventNo: number) => {
    return eventNo === 8 && isLockerTask ? 'eventHistory.events.26' : 'eventHistory.events.' + eventNo;
  };

  const shouldShowPhotos = (eventNo: number) => {
    return (eventNo === 23 && isLockerTask) || (eventNo === 8 && !isLockerTask);
  };

  return (
    <Container>
      <Row className="package_history">
        <Col style={{ paddingRight: 0 }}>
          <div className="package_history--header">{t('eventHistory.heading')}</div>
          <div className="timeline">
            {trackingEvents.length > 0 &&
              trackingEvents.map((trackingEvent: { eventNo: number; datetime: Date }, index) => {
                return (
                  <Fragment key={'trackingEvent_' + index}>
                    <div className="timeline__component_left">
                      <div className="timeline__time--right">
                        <b>{dayjs(trackingEvent.datetime).format('HH:mm')}</b>
                      </div>
                      <div className="timeline__date--right">{dayjs(trackingEvent.datetime).format('YYYY-MM-DD')}</div>
                    </div>
                    <div
                      className={
                        trackingEvents.length !== 1
                          ? `timeline__middle ${index === 0 ? 'timeline__middle--top' : ''} ${
                              index === trackingEvents.length - 1 ? 'timeline__middle--bottom' : ''
                            }`
                          : ''
                      }
                    >
                      <div
                        className={
                          trackingEvents.length !== 1
                            ? `timeline__point ${index === 0 ? 'timeline__point--latest' : 'timeline__point--old'} ${
                                index === trackingEvents.length - 1 ? 'timeline__point--bottom' : ''
                              }`
                            : ''
                        }
                      ></div>
                    </div>
                    <div className={`timeline__component_right ${index === trackingEvents.length - 1 ? 'timeline__component__right--bottom' : ''}`}>
                      <div className="timeline__component--bg">
                        {[3, 7, 12, 21, 22].includes(trackingEvent.eventNo) ? (
                          t('eventHistory.events.' + trackingEvent.eventNo).replace(/(##partnerName##)/, settings?.displayName || partner?.name || 'Velove')
                        ) : trackingEvent.eventNo === 25 ? (
                          t('eventHistory.events.' + trackingEvent.eventNo)
                            .replace(/(##lockerExpiresInDays##)/, settings?.lockerReservationExpiresInDays?.toString() || '5')
                            .replace(/(##partnerName##)/, settings?.displayName || partner?.name || 'Velove')
                        ) : trackingEvent.eventNo === 5 ? (
                          trackingDetails?.stopsAhead ? (
                            t('eventHistory.events.' + trackingEvent.eventNo + '.1')
                          ) : (
                            t('eventHistory.events.' + trackingEvent.eventNo + '.2')
                          )
                        ) : shouldShowPhotos(trackingEvent.eventNo) ? (
                          <div>
                            {t(getEventTranslationKey(trackingEvent.eventNo))}
                            {renderPhotos()}
                          </div>
                        ) : (
                          t(getEventTranslationKey(trackingEvent.eventNo))
                        )}
                      </div>
                    </div>
                  </Fragment>
                );
              })}
          </div>
        </Col>
      </Row>
      <Modal show={isOpenImages} onHide={() => setIsOpenImages(false)} animation={false} centered fullscreen={true}>
        <Modal.Header closeButton>
          <Modal.Title className="delivery-confirmation--header">{t('feedback.deliveryConfirmationHeader')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box m={2}>
            {trackingDetails?.verifiedPhotoUrls && trackingDetails.verifiedPhotoUrls.length > 0 && (
              <Fragment>
                {trackingDetails.verifiedPhotoUrls.map((photoUrl, index) => {
                  return <img alt="photoVerification" key={`verifiedPhoto_${index}`} className="feedback_success_modal--img" src={photoUrl} />;
                })}
              </Fragment>
            )}
          </Box>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default TrackingHistory;
